import { Component, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { StreamService } from '../services';

@Component({
    template: `
        <create-rss-source *ngIf="sourceType === 'RSS'" (resultsFetched)="resultsFetched($event)" (matchFound)="matchFound($event)" (save)="save($event)"></create-rss-source>
        <create-twitter-source *ngIf="sourceType === 'TWITTER_SEARCH'" (resultsFetched)="resultsFetched($event)" (matchFound)="matchFound($event)" (save)="save($event)"></create-twitter-source>
        <create-bing-source *ngIf="sourceType === 'BING_SEARCH'" (resultsFetched)="resultsFetched($event)" (matchFound)="matchFound($event)" (save)="save($event)"></create-bing-source>
        <create-pub-med-source *ngIf="sourceType === 'PUBMED_SEARCH'" (resultsFetched)="resultsFetched($event)" (matchFound)="matchFound($event)" (save)="save($event)"></create-pub-med-source>
        <create-factiva-select-source *ngIf="sourceType === 'FACTIVA_SELECT_HTTP'" (save)="save($event)"></create-factiva-select-source>
        <create-clinical-trials-source *ngIf="sourceType === 'CLINICALTRIALS_SEARCH'" (resultsFetched)="resultsFetched($event)" (matchFound)="matchFound($event)" (save)="save($event)"></create-clinical-trials-source>
        <create-scopus-source *ngIf="sourceType === 'SCOPUS_SEARCH'" (resultsFetched)="resultsFetched($event)" (matchFound)="matchFound($event)" (save)="save($event)"></create-scopus-source>
        <create-diffbot-source *ngIf="sourceType === 'DIFFBOT_SEARCH'" (resultsFetched)="resultsFetched($event)" (matchFound)="matchFound($event)" (save)="save($event)"></create-diffbot-source>
        <import-opml *ngIf="sourceType === 'OPML'"></import-opml>
        <create-source-preview-results [results]="results" [match]="match"></create-source-preview-results>
    `
})
export class CreateSourceComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    sourceType: string;
    results: any;
    match: any;
     
    constructor(private route: ActivatedRoute, 
                private router: Router, 
                private snackbar: MatSnackBar,
                private streamService: StreamService) {
        route.params.pipe(takeUntil(this.cleanupTime)).subscribe(params => this.sourceType = params.sourceType);
    }

    resultsFetched(results) {
        this.match = undefined;
        this.results = results;
    }

    matchFound(match) {
        this.match = match;
        this.results = undefined;
    }

    save(stream) {
        const isCatalog = this.route.snapshot.data.isCatalog;
        (isCatalog ? this.streamService.saveCatalogStream(stream) :  this.streamService.saveStream(stream))
        .pipe(map(savedStream => ['../../', savedStream.id, 'settings']))
        .subscribe(
            path => this.router.navigate(path, { relativeTo: this.route }),
            () => this.snackbar.open('An error occurred when attempting to save this source', 'OK',  { duration: 5000 })
        );
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}